// import lib
import Loadable from 'react-loadable'

// import components
import Loading from './../loaders/Loading'

const routes = [
    {
        path: '/:supervisorId',
        exact: true,
        status:'HOME',
        component: Loadable({
          loader: () => import('../../SupervisorHome/SupervisorHome'),
          loading: Loading,
        }),
      }, 
      {
        path: '/timecard/:timecardId/:supervisorId',
        exact: true,
        component: Loadable({
          loader: () => import('../../TimecardComponent/Timecard'),
          loading: Loading,
        }),
      },
  {
    path: '/:confirmation/:timecardId/:supervisorId',
    exact: true,
    component: Loadable({
      loader: () => import('./../../Confirmation/ConfirmationPage/ConfirmationPage'),
      loading: Loading,
    }),
  },
  {
    path: '*',
    exact: true,
    component: Loadable({
      loader: () => import('../../SupervisorHome/SupervisorHome'),
      loading: Loading,
    }),
  },
  
  
]

export default routes